const DESIGN_WIDTH = 1920;
const DESIGN_HEIGHT = 1080;

let scale = 1;

/**
 * The viewport the scale is measured against. It only ever grows while the
 * width stays put: webOS shrinks the window when the IME keyboard comes up, and
 * measuring that resize would scale the whole canvas down to the strip left
 * above the keyboard — the app ends up a small picture in the top-left corner,
 * since the canvas scales from its top-left. A width change is a real viewport
 * change (a different panel, or a browser window dragged in dev), so it resets
 * the latch and both axes are measured afresh.
 */
let measuredWidth = 0;
let measuredHeight = 0;

//Convert pixels to scaled design units - used for offsets
export function toDesignPx(physicalPx: number): number {
  return physicalPx / scale;
}

function measure(): number {
  const width = window.innerWidth || DESIGN_WIDTH;
  const height = window.innerHeight || DESIGN_HEIGHT;

  if (width === measuredWidth) {
    measuredHeight = Math.max(measuredHeight, height);
  } else {
    measuredWidth = width;
    measuredHeight = height;
  }

  return Math.min(measuredWidth / DESIGN_WIDTH, measuredHeight / DESIGN_HEIGHT, 1);
}

function apply(): void {
  scale = measure();

  const root = document.documentElement;
  root.style.setProperty('--app-scale', `${scale}`);

  //Toggle CSS scale
  if (scale < 1) {
    root.setAttribute('data-scaled', '');
  } else {
    root.removeAttribute('data-scaled');
  }
}

export function initScale(): void {
  apply();
  window.addEventListener('resize', apply);
}
